import React from 'react';

function VerticalDots(props) {
    const fill = props.fill || 'currentColor';
    const secondaryfill = props.secondaryfill || fill;
    const strokewidth = props.strokewidth || 1;
    const width = props.width || '1em';
    const height = props.height || '1em';

    return (
        <svg height={height} width={width} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <g fill={fill} stroke="none">
                <circle cx="12" cy="5" r="2" />
                <circle cx="12" cy="12" r="2" />
                <circle cx="12" cy="19" r="2" />
            </g>
        </svg>
    );
};

export default VerticalDots; 